import request from "@/utils/request";

export function getWxAuthUrl(params) {
  return request({
    url: "/User/WxAuth/GetAuthUrl",
    method: "get",
    params,
  });
}

export function callbackWxAuth(params) {
  return request({
    url: "/User/WxAuth/Callback",
    method: "get",
    params,
  });
}

export function bindWxAccount(data) {
  return request({
    url: "/User/WxAuth/BindAccount",
    method: "post",
    data,
  });
}

export function registerByWx(data) {
  return request({
    url: "/User/WxAuth/RegisterByWx",
    method: "post",
    data,
  });
}
